import React, { FunctionComponent, useState } from 'react';
import HomeIllustration from '../../assets/illustration1.svg';
import './style.less';
import { useHistory } from "react-router-dom";
import { Row, Col, Typography, Input, Radio, Card, RadioChangeEvent } from 'antd';
import { HomeResources } from '../../resources';

const { Title } = Typography;
const { Search } = Input;

enum DomainCategory {
    Premium,
    Discounted,
    Free,
}

const ALL_DOMAIN_CATEGORY = [DomainCategory.Discounted, DomainCategory.Free, DomainCategory.Premium];

interface HomeProps {}

const Home: FunctionComponent<HomeProps> = () =>
{
    const history = useHistory();
    const [search, setSearch] = useState<string>('');
    const [filter, setFilter] = useState<string>('');
    const [domainCategory, setDomainCategory] = useState<DomainCategory[]>(ALL_DOMAIN_CATEGORY);
    console.log(domainCategory)
    const handleSearch = (value: string) =>
    {
       if(value) history.push('/domains/' + search)
    };
    const handleModeChange = ({ target: { value } }: RadioChangeEvent) => setFilter(value);

    return (
        <div className="Home">
            <div
                className="page-head-background"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/background.svg'})`,
                }}
            >
                <div className="slide-1">
                    <Row>
                        <Col lg={10} offset={2} className="slide-1-span">
                            <Row>
                                <Col span={24}>
                                    <Title>{SEARCH_TITLE}</Title>
                                    <p>{SEARCH_DES}</p>
                                </Col>
                                <Col span={24}>
                                    <Search
                                        size="large"
                                        placeholder={SEARCH_PLACEHOLDER}
                                        onSearch={handleSearch}
                                        onChange={(e) => setSearch(e.target.value)}
                                        value={search}
                                        enterButton
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col className="slide-1-illustration" lg={10} offset={2}>
                            <img src={HomeIllustration} alt="hepnox illustration" />
                        </Col>
                    </Row>
                </div>
                <div>
                    <br />
                    <br />
                    <br />
                    <Title className="text-center">{DOMAIN_LIST_TITLE}</Title>
                    <Radio.Group onChange={handleModeChange} value={filter} style={{ marginBottom: 8 }}></Radio.Group>
                    <Radio.Group size="large"  className="element-center" style={{ marginBottom: 8 }}>
                        <Radio.Button
                            value={ALL_DOMAIN_CATEGORY}
                            onClick={() => setDomainCategory(ALL_DOMAIN_CATEGORY)}
                        >
                            All
                        </Radio.Button>
                        <Radio.Button
                            value={DomainCategory.Premium}
                            onClick={() => setDomainCategory([DomainCategory.Premium])}
                        >
                            Premium
                        </Radio.Button>
                        <Radio.Button
                            value={[DomainCategory.Discounted]}
                            onClick={() => setDomainCategory([DomainCategory.Discounted])}
                        >
                            Discounted
                        </Radio.Button>
                        <Radio.Button
                            value={[DomainCategory.Free]}
                            onClick={() => setDomainCategory([DomainCategory.Free])}
                        >
                            Free
                        </Radio.Button>
                    </Radio.Group>
                    <div className="element-center">
                        {/* <div className="element-center gallery mx-10"> */}
                            <Row className="element-center">
                                {DOMAIN_LIST.map((card, i) => (
                                    <Col className="element-center mx-10">
                                        <Card className="shadow" style={{ width: 280 }} key={i} title={card.title} actions={[
                                            <a href="####" >Check Availability</a>
                                        ]} >
                                            <p style={{ opacity: .5 }} >{card.des}</p>
                                            <div>
                                                <del>{PRICE_TEMPLATE(card.price)}</del><br/>
                                                <span className="price-text">{PRICE_TEMPLATE(card.dPrice)}</span>
                                                {/* <p>Category {domainCategory}</p> */}
                                            </div>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;

const { SEARCH_DES, SEARCH_TITLE, SEARCH_PLACEHOLDER, DOMAIN_LIST, DOMAIN_LIST_TITLE, PRICE_TEMPLATE } = HomeResources;
